import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-spin-winner" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { computed } from "vue";
import { bonImgUrl } from "../../../utils/image-src";
import { SpinAutomatState } from "../../../models/bonusomat-spin-types";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-spin-winner',
  props: {
    state: {},
    prizeText: {}
  },
  setup(__props: any) {

const props = __props;

const winnerImage = computed(() => bonImgUrl("sack-with-money", "png"));

const winnerNote = computed(() => (props.state === "DISABLED" ? "Další zatočení za" : ""));

const winnerText = computed(() => {
    if (props.state === "DISABLED") {
        const midnight = new Date();
        midnight.setHours(24);
        midnight.setMinutes(0);
        midnight.setSeconds(0);
        midnight.setMilliseconds(0);

        const duration = DateTimeUtils.getDuration(midnight.getTime() - Date.now());

        return `<strong>${duration.h} ${DateTimeUtils.formatAfterXHoursLabel(duration.h)} a ${
            duration.m
        } ${DateTimeUtils.formatAfterXMinutesLabel(duration.m)}</strong>`;
    }

    if (props.state === "WINNING" && props.prizeText) {
        return props.prizeText;
    }

    return "<strong>Zde se zobrazí<br> vaše výhra<strong>";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WebpImage, {
      class: "bonusomat-spin-winner__image",
      src: winnerImage.value,
      alt: "symbol výhry - pytel s penězi"
    }, null, 8, ["src"]),
    _withDirectives(_createElementVNode("div", {
      class: "bonusomat-spin-winner__note",
      innerHTML: winnerNote.value
    }, null, 8, _hoisted_2), [
      [_vShow, winnerNote.value]
    ]),
    _createElementVNode("h3", {
      class: "bonusomat-spin-winner__text",
      innerHTML: winnerText.value
    }, null, 8, _hoisted_3)
  ]))
}
}

})